import { DEFAULT_STATE } from "./state"

export default {
  reset: (state) => { Object.assign(state, DEFAULT_STATE) },

  set: (state, payload) => { Object.assign(state, payload) },
}
